module.exports = require('./TriviaSansBook')
